<template>
  <el-dialog
    append-to-body
    width="600px"
    title="新建账号"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="姓名">
        <el-input
          clearable
          v-model="form.data.name"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="account" label="账号">
        <el-input
          clearable
          v-model="form.data.account"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <el-input
          v-model.trim="form.data.password"
          prefix-icon="el-icon-lock"
          clearable
          show-password
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item prop="role_type" label="权限">
        <el-radio-group v-model="form.data.role_type">
          <el-radio :label="1">超级管理员</el-radio>
          <el-radio :label="2">代理</el-radio>
          <el-radio :label="3">企业</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import common from "@/util";
export default {
  name: "WealEdit",
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          account: "",
          name: "",
          password:'',
          role_type:'',
        },
        rules: {
          account: [{ required: true, message: "必填项", trigger: "change" }],
          name: [{ required: true, message: "必填项", trigger: "change" }],
          role_type: [{ required: true, message: "必填项", trigger: "change" }],
          password: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    reset(done) {
      this.isChange = false;
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          this.$http
            .post('/admin/admin/add', this.form.data)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
